<template>
  <div class="teaser-small">
    <div class="content">
      <h3 v-if="data.title" class="title" v-html="data.title" />
      <StructuredText v-if="data.lead" class="structured-text lead" :data="data.lead" />
    </div>
    <Link v-if="data.link" :link="data.link" class="button-primary button" icon-position="left" />
  </div>
</template>

<script setup lang="ts">
import { StructuredText } from 'vue-datocms';
import type { TeaserSmallFragment } from '#gql';
import Link from '~/components/content-modules/components/Link.vue';

defineProps<{
  data: TeaserSmallFragment;
}>();
</script>

<style scoped lang="scss">
.teaser-small {
  background-color: var(--color-white);
  padding: var(--spacing-xs);
  width: 100%;
  height: 100%;
  display: grid;
  align-content: space-between;
  justify-items: start;

  @media (--xs), (--sm) {
    min-height: 17rem;
  }

  @media (--md), (--lg) {
    min-height: 14.5rem;
  }

  > .content > .title {
    margin-bottom: var(--spacing-3xs);
  }

  :deep(.title),
  :deep(.button) {
    color: var(--color-forest-dark);
  }

  :deep(.button) {
    margin-top: calc(2 * var(--spacing-3xs));

    &:focus-visible {
      border: 2px solid var(--color-forest-dark);
    }

    > .iconwrapper {
      background: var(--color-turquoise);

      > .icon {
        fill: var(--color-white);
      }
    }
  }
}
</style>
